export default "__VITE_ASSET__D2l9fB4N__"